var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5308 16.28C12.3902 16.4205 12.1996 16.4994 12.0008 16.4994C11.8021 16.4994 11.6114 16.4205 11.4708 16.28L3.97082 8.78003C3.83834 8.63786 3.76622 8.44981 3.76965 8.25551C3.77308 8.06121 3.85179 7.87582 3.9892 7.73841C4.12661 7.601 4.312 7.52228 4.5063 7.51886C4.7006 7.51543 4.88865 7.58755 5.03082 7.72003L12.0008 14.69L18.9708 7.72003C19.0395 7.64634 19.1223 7.58724 19.2143 7.54625C19.3063 7.50526 19.4056 7.48322 19.5063 7.48144C19.607 7.47966 19.707 7.49819 19.8004 7.53591C19.8938 7.57363 19.9786 7.62977 20.0499 7.70099C20.1211 7.77221 20.1772 7.85705 20.2149 7.95043C20.2527 8.04382 20.2712 8.14385 20.2694 8.24455C20.2676 8.34526 20.2456 8.44457 20.2046 8.53657C20.1636 8.62857 20.1045 8.71137 20.0308 8.78003L12.5308 16.28Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.deb32adadc3410ec56715c28b3f09000.svg";
export { ForwardRef as ReactComponent };